import React from "react";
import Icon, { IconProps } from "./Icon";

/**
 * Hajj and Umrah icon representing Islamic pilgrimage
 */
export const HajjUmrahIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      {/* Kaaba representation */}
      <rect x="7" y="7" width="10" height="10" rx="1"></rect>
      
      {/* Tawaf (circumambulation) representation */}
      <path d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z" fill="none"></path>
      
      {/* Door of Kaaba */}
      <line x1="11" y1="17" x2="13" y2="17"></line>
      
      {/* Black Stone corner indication */}
      <path d="M7 12 L7 7 L8 7" strokeWidth="1.5"></path>
    </Icon>
  );
};

export default HajjUmrahIcon;
